module.exports = __webpack_public_path__ + "static/img/chuzhongyingyu.e26e56a0.jpg";